import {PiPolygonLight , PiFilePdfLight  } from "react-icons/pi";
import { IoIosAttach } from "react-icons/io";

export const FileIcon = ({fileExtension}) => {

    const styling = "w-8 h-8 m-2 text-gray-600";

    switch (fileExtension) {
        case 'pdf':
            return <PiFilePdfLight className={styling}/>
        case 'gml':
            return <PiPolygonLight className={styling}/>
        default:
            return <IoIosAttach className={styling}/>
    }
}